import Cookies from "js-cookie";

class Util {
    static setCookiePoint(clickedUsertype) {
        var cookieUser = this.getUserCookie();

        cookieUser["scores"][clickedUsertype] += Math.exp((-cookieUser["rateos"][clickedUsertype]) * 3);
        cookieUser["total_action"] += 1;

        this.setUserCookie(cookieUser);

        return true;
    }

    static setUserCookie(payload) {
        return Cookies.set("user", payload, {expires: 30});
    }

    static getUserCookie() {
        return JSON.parse(Cookies.get("user"));
    }
}

export default Util;



// WEBPACK FOOTER //
// ./scripts/util/Util.js